import { SegmentClassificationMapModel } from "../models/SegmentClassificationMapModel";
import { client } from "./API";

const SegmentClassificationMapService = {
  async getSegmentClassificationMap() {
    const response = await client({
      url: "SegmentClassification/GetSegmentClassificationMap",
      method: "get",
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
    return response.data;
  },
  async createSegmentClassificationMap(data: SegmentClassificationMapModel) {
    try {
      const response = await client({
        method: "post",
        url: "SegmentClassification/PostSegmentClassificationMap",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  async deleteSegmentClassificationMap(data: SegmentClassificationMapModel) {
    try {
      const response = await client({
        method: "delete",
        url: "SegmentClassification/DeleteSegmentClassificationMap",
        data: data,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
};
export default SegmentClassificationMapService;
